export const partnersSection = {
  title: 'Socios',
  description:
    'Nos esforzamos por convertirnos en líderes trabajando sólo con socios fiables y de confianza con un nombre conocido. Cada una de nuestras selecciones se basa en altos estándares de calidad y profesionalidad para proporcionar a nuestros clientes sólo lo mejor del mundo de la innovación. Creemos que sólo la cooperación mutuamente beneficiosa y honesta con nuestros socios le ayudará a convertirse en el propietario de la casa de sus sueños.',
};
